/* eslint-disable indent */
import { AxiosError } from 'axios';

import { createAction } from '@reduxjs/toolkit';

export const createActionTypes = (action: string) => ({
  ASYNC: `ASYNC_${action.toUpperCase()}`,
  START: `START_${action.toUpperCase()}`,
  STOP: `STOP_${action.toUpperCase()}`,
  FILL: `FILL_${action.toUpperCase()}`,
  ERROR: `ERROR_${action.toUpperCase()}`,
});

/**
 *
 * @typeParam `R` the request payload type
 * @typeParam `S` the success payload type
 * @typeParam `F` the failure payload type
 */

export const createApiActions = <R = any, S = any, F = AxiosError>(
  actionTypes: ReturnType<typeof createActionTypes>,
) => ({
  async: createAction<R>(actionTypes.ASYNC),
  start: createAction(actionTypes.START),
  stop: createAction(actionTypes.STOP),
  fill: createAction<S>(actionTypes.FILL),
  error: createAction<F>(actionTypes.ERROR),
});

/**
 *
 * @typeParam `T` response
 * @typeParam `P` payload params
 */

export type ActionPromise<T, P> = {
  resolve: (result?: T) => void;
  reject: (e?: any) => void;
  payload: P;
  type: string;
};
